import { render, staticRenderFns } from "./add-product-component.vue?vue&type=template&id=c7eedfbe&scoped=true"
import script from "./add-product-component.vue?vue&type=script&lang=js"
export * from "./add-product-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7eedfbe",
  null
  
)

export default component.exports